module.exports = __webpack_public_path__ + "media/images/icon-arrow-up-a580344acc6a871bcbb8e6af2c229619.png";